import {
  SignIn as SignInRoot,
  SignInAuthMethodButtons,
  SignInBackButton,
  SignInDescription,
  SignInFooter,
  SignInForm,
  SignInImage,
  SignInProps as SignInRootProps,
  SignInTitle,
  useAppConfig,
} from '@coinbase/cdp-react';

import styles from './SignIn.module.css';

type SignInProps = Omit<SignInRootProps, 'children'> & {
  isOpen: boolean;
};

export function SignIn({ onSuccess, className = '', isOpen }: SignInProps) {
  const { showCoinbaseFooter } = useAppConfig();
  return (
    <div className={styles['sign-in-wrapper']} data-state={isOpen ? 'open' : 'closed'}>
      <SignInRoot
        onSuccess={onSuccess}
        className={`${className} ${styles['sign-in']} ${!showCoinbaseFooter ? styles['no-footer'] : ''}`}
      >
        <>
          <div className={styles.buttons}>
            <SignInBackButton className={styles['back-button']} />
          </div>
          <SignInForm onSuccess={onSuccess}>
            {({ authMethod, step, Form }) => {
              if (authMethod.startsWith('siwe:') && step === 'verification') {
                return <div>{Form}</div>;
              }
              return (
                <>
                  <SignInImage authMethod={authMethod} step={step} />
                  <div className={styles['title-desc-wrapper']}>
                    <SignInTitle className={step === 'verification' ? 'sr-only' : ''} />
                    <SignInDescription
                      className={step === 'credentials' ? 'sr-only' : ''}
                      authMethod={authMethod}
                    />
                  </div>
                  <div className={styles['sign-in-form']}>{Form}</div>
                  {step === 'credentials' && (
                    <SignInAuthMethodButtons activeMethod={authMethod} onSuccess={onSuccess} />
                  )}
                </>
              );
            }}
          </SignInForm>
          {showCoinbaseFooter && <SignInFooter className={styles.footer} />}
        </>
      </SignInRoot>
    </div>
  );
}
